import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    IInitialStateNormTypes, INormTypesPayload
} from "../types";
import {
    GetDeleteNormTypes,
    GetNormTypes
} from './thunk';



const initialState:IInitialStateNormTypes ={
    normTypes:[],
    isLoadingNormTypes:false,
    filteredNormTypes:[],
    selectedNormTypesIDs:[],
    isViewRestoreNormTypes:false,
    normTypesRestore:[]
}


const normTypesSlice = createSlice({
    name:"normTypesSlice",
    initialState,
    reducers:{
        setNormTypes: (state, action: PayloadAction<{data:INormTypesPayload[],defaultLanguage:string}>) => {
            const { data,defaultLanguage } = action.payload;

            state.normTypes = data;
            state.filteredNormTypes = state.normTypes.flatMap(
                (data) =>
                    data.translations
                        .filter((elem) => elem.slug === defaultLanguage && elem.name)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name as string,

                        }))
            );

        },
        setIsViewRestoreNormTypes: (state) => {

            state.isViewRestoreNormTypes = !state.isViewRestoreNormTypes;
        },
        deletedRestoreNormTypes:(state,action)=>{
            const updateData = state.normTypesRestore.filter(
                (elem) => elem.id !== action.payload
            );
            state.normTypesRestore = updateData;
        },

        deleteNormTypes: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            const updatedData = state.normTypes.filter(
                (elem) => elem.id !== id
            );
            state.normTypes = updatedData;
        },
        updateNormTypes: (
            state,
            action: PayloadAction< INormTypesPayload>
        ) => {
            const updateData = action.payload;

            state.normTypes = state.normTypes.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },

        setSelectedNormTypesIDs: (state, action) => {
            state.selectedNormTypesIDs=action.payload
        },
        setNormTypesRestoreData:(state, action) => {
            state.normTypesRestore = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetNormTypes.pending, (state) => {
                state.isLoadingNormTypes = true;
            })
            .addCase(GetNormTypes.fulfilled, (state) => {
                state.isLoadingNormTypes = false;
            })
            .addCase(GetNormTypes.rejected, (state) => {
                state.isLoadingNormTypes = false;
            })
            .addCase(GetDeleteNormTypes.pending, (state) => {
                state.isLoadingNormTypes = true;
            })
            .addCase(GetDeleteNormTypes.fulfilled, (state) => {
                state.isLoadingNormTypes = false;
            })
            .addCase(GetDeleteNormTypes.rejected, (state) => {
                state.isLoadingNormTypes = false;
            });
    },

})

export const{
    setNormTypes,
    setIsViewRestoreNormTypes,
    deletedRestoreNormTypes,
    deleteNormTypes,
    updateNormTypes,
    setSelectedNormTypesIDs,
    setNormTypesRestoreData
}=normTypesSlice.actions

export default normTypesSlice